import { Avatar, Button, Checkbox, Modal } from "antd";
import React from "react";

export const ApprovalModal = ({
    modalOpen,
    setModalOpen,
    allUsers,
    setAllUsers,
    selectedUsers,
    toggleSelection,
    handleSend,
    loading,
    isRestrictedRole,
}) => (
    <Modal
        title="Set Approval Matrix"
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        width={600}
    >
        <div className="space-y-2 max-h-[60vh] overflow-auto">
            {allUsers.map((user) => (
                <div key={user.id} className="flex flex-col gap-2 p-2 mb-2 border rounded shadow-sm">
                    <div className="flex items-center gap-3">
                        {!isRestrictedRole && (
                            <Checkbox
                                checked={selectedUsers.includes(user.id)}
                                onChange={() => toggleSelection(user)}
                            />
                        )}
                        <Avatar>{user.first_name && user.first_name[0]}</Avatar>
                        <div>
                            <div className="font-semibold">{user.first_name}</div>
                            <div className="text-sm text-gray-500">{user.email}</div>
                        </div>
                    </div>
                    {selectedUsers.includes(user.id) && !isRestrictedRole && (
                        <textarea
                            placeholder="Add remarks..."
                            className="border rounded p-2 mt-1 w-full text-sm"
                            value={user.remarks || ""}
                            onChange={(e) =>
                                setAllUsers((prev) =>
                                    prev.map((u) =>
                                        u.id === user.id ? { ...u, remarks: e.target.value } : u
                                    )
                                )
                            }
                        />
                    )}
                </div>
            ))}
        </div>

        {!isRestrictedRole && (
            <>
                <div className="flex justify-end mt-4">
                    <Button
                        type="primary"
                        onClick={() => handleSend("top")}
                        loading={loading}
                    >
                        Done
                    </Button>
                </div>
            </>
        )}
    </Modal>
);
